'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.createPostMessageAction = undefined;

var _q = require('q');

var _q2 = _interopRequireDefault(_q);

var _getIframeUuid = require('../../iframeUuid/selectors/getIframeUuid');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var createPostMessageAction = exports.createPostMessageAction = function createPostMessageAction(type) {
  return function (data) {
    return function (dispatch, getState) {
      var uuid = (0, _getIframeUuid.getIframeUuid)(getState());

      return new _q2.default.Promise(function (resolve, reject) {
        try {
          parent.postMessage(JSON.stringify({
            type: type,
            data: data,
            uuid: uuid
          }), '*');
          resolve({ type: type, data: data });
        } catch (e) {
          reject(e);
        }
      });
    };
  };
};